import styled, { css } from 'styled-components';

import { utils } from '@desygner/ui-common-components';

export const StyledWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => utils.rem(theme.Spacing.Size.XXSmall)};
`;

export const StyledInputWrapper = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: ${utils.rem(75)};
  ${({ theme }) => css`
    padding: ${utils.rem(theme.Spacing.Size.XSmall)};
    border-radius: ${utils.rem(theme.Border.Radius.Medium)};
    border: ${utils.rem(theme.Border.Size.Small)} solid ${theme.Color.Neutrals.Border};
  `}

  cursor: pointer;
`;
